/**
 * Sanitizes phone numbers to E.164 format without leading zeros or '+' for wa.me.
 * Defaults to country code '351' (Portugal) if a 9-digit local number is provided.
 * Mirrors eurosys-site/src/lib/builder/whatsAppLink.ts sanitizePhone — keep in sync.
 */
export function sanitizeWaPhone(rawPhone?: string): string {
  if (!rawPhone) return "";
  const digits = String(rawPhone).replace(/[^\d]/g, "");
  if (!digits) return "";
  // International prefix 00 → strip (00351… → 351…, 0034… → 34…).
  if (digits.startsWith("00")) return digits.slice(2);
  // Legacy leading zero on a national number (09… → 9…) before the 9-digit rule.
  if (digits.length === 10 && digits.startsWith("0"))
    return `351${digits.slice(1)}`;
  // 9-digit local number → default PT country code.
  if (digits.length === 9 && /^[23789]/.test(digits)) return `351${digits}`;
  // A 9-digit number starting with 0 is neither a PT national number nor a
  // valid E.164 — reject (return "") so the caller hides the CTA.
  if (digits.length === 9 && digits.startsWith("0")) return "";
  return digits;
}
